import { useJobillaOrgId } from '@/hooks/useJobillaOrgId'
import { logger } from '@/ui'
import { useWhatsAppEmbeddedSignupStatus } from '@jobilla/nexus-sdk'
import { useEffect } from 'react'

/**
 * Returns whether WhatsApp is enabled for the current organisation.
 * Reads from the org-level `whatsapp_enabled` flag via the WhatsApp status endpoint.
 * Falls back to false on error (hides WhatsApp UI as a safe default).
 */
export function useWhatsAppEnabled(): boolean {
	const organisationId = useJobillaOrgId()

	const { data, error } = useWhatsAppEmbeddedSignupStatus(organisationId, {
		staleTime: 5 * 60 * 1000,
		retry: (failureCount, error) => {
			const status = error.response?.status
			if (status && status >= 500) { return false }
			return failureCount < 3
		},
	})

	useEffect(() => {
		if (error) {
			logger.error(error, {
				category: 'whatsapp',
				data: { action: 'check-whatsapp-enabled', organisationId },
			})
		}
	}, [error, organisationId])

	return Boolean(data?.whatsappEnabled)
}
